import LangEnum from '../../../../../lang/LangEnum';
import { RoleType } from '../../../../orders/actions/types/actions.types';
import { AvailabilityEnum } from '../../../../products/ProductTypes';
import { OfflineOrder } from '../OfflineOrder';
import OfflineOrderRule from './OfflineOrder.rule';

export enum OfflineOrderRulesTo {
  VALIDATE_GENERAL_DATA = 'VALIDATE_GENERAL_DATA',
  VALIDATE_PRODUCTS = 'VALIDATE_PRODUCTS',
  VALIDATE_CONDITIONS = 'VALIDATE_CONDITIONS',
}

export interface ValidateOfflineOrderRuleParams {
  order: OfflineOrder;
  userRole: RoleType;
}

interface SuccessValidateOutput {
  hasErrors: false;
}

interface ErrorValidateOutput {
  hasErrors: true;
}

interface ValidateGeneralDataOutput extends ErrorValidateOutput {}

interface ValidateProductsOutput extends ErrorValidateOutput {
  error: Error;
  orderProductsWithError: OrderProductWithError[];
}

interface ValidateConditionsOutput extends ErrorValidateOutput {}

interface Error {
  messageCode: LangEnum;
}

export interface OrderProductWithError {
  productId: string;
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
  extra?: OrderProductRuleExtraDetails;
}

interface OrderProductRuleExtraDetails {
  minimumQuantity?: number;
  achievedQuantity?: number;
}

type ValidateGeneralDataRuleOutput = ValidateGeneralDataOutput | SuccessValidateOutput;
type ValidateProductsRuleOutput = ValidateProductsOutput | SuccessValidateOutput;
type ValidateConditionsRuleOutput = ValidateConditionsOutput | SuccessValidateOutput;

export interface OfflineOrderRulesReturnMap {
  [OfflineOrderRulesTo.VALIDATE_GENERAL_DATA]: ValidateGeneralDataRuleOutput;
  [OfflineOrderRulesTo.VALIDATE_PRODUCTS]: ValidateProductsRuleOutput;
  [OfflineOrderRulesTo.VALIDATE_CONDITIONS]: ValidateConditionsRuleOutput;
}

export interface ValidateParams<T extends keyof OfflineOrderRulesReturnMap> {
  order: OfflineOrder;
  rules: OfflineOrderRule<T>[];
  userRole: RoleType;
}
